import { HomePage } from "./../home/home";
// import { PlazaThemeChangePage } from "./../plaza-theme-change/plaza-theme-change";
import { TranslateService } from "@ngx-translate/core";
import { PlazaSelectThemeSavePage } from "./../plaza-select-theme-save/plaza-select-theme-save";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
import { PlazaSlotThemePage } from "../plaza-slot-theme/plaza-slot-theme";

@IonicPage()
@Component({
  selector: "page-plaza-select-theme",
  templateUrl: "plaza-select-theme.html",
})
export class PlazaSelectThemePage {
  themes: any;
  MyThemes: any;
  check = 0;
  theme1 = "";
  theme2 = "";
  url: any;
  budget: any;
  themeNo = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.themeNo = this.navParams.data.themeNo;
  }

  async ionViewDidLoad() {
    // this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLTheme;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.themes = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link2 = this.services.URLGetTheme;

      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.MyThemes = data;
            this.check = data.length;

            let i = 1;
            this.MyThemes.forEach((element) => {
              if (i == 1) {
                this.theme1 = element.theme.theme_id;
              } else {
                this.theme2 = element.theme.theme_id;
              }
              i++;
            });
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      this.storage.get("info").then((info) => {
        if (info.role == 1) {
          this.url = this.services.URLPlazaStatBudgets;
        } else if (info.role == 2) {
          this.url = this.services.URLMerchantStatBudgets;
        } else if (info.role == 3) {
          this.url = this.services.URLShopperStatBudgets;
        }
        var link = this.url;

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.budget = this.services.currencyFormat(data.available);
            },
            (error) => {
              // console.log(error);
              this.services.presentToastInternet();
            }
          );
      });
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLTheme;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.themes = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link2 = this.services.URLGetTheme;

      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.MyThemes = data;
            this.check = data.length;

            let i = 1;
            this.MyThemes.forEach((element) => {
              if (i == 1) {
                this.theme1 = element.theme.theme_id;
              } else {
                this.theme2 = element.theme.theme_id;
              }
              i++;
            });
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });

    refresher.complete();
  }

  backPage() {
    this.navCtrl.setRoot(PlazaSlotThemePage);
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  selectTheme(val) {
    this.navCtrl.push(PlazaSelectThemeSavePage, {
      theme: val,
      themeNo: this.themeNo,
    });
  }

  // changeTheme(val) {
  //   this.navCtrl.push(PlazaThemeChangePage, { theme: val });
  // }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-select-theme/plaza-select-theme.ts